import styled from 'styled-components';

export const StyledTaskFormRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;

export const StyledFormRowHeading = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledFormRowDescription = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledBottomLine = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border.dropdown};
  margin-top: 3.2rem;
  margin-bottom: 3.2rem;
`;

export const StyledTaskFormRowHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;
